<template>
  <div class="our-advantages">
 <div class="swiper-wrapper" v-loading="advantageSwiperLoading" >
      <swiper
        v-if="bannerArray.length > 0"
        :options="swiperOptionTop"
        class="gallery-top"
        ref="swiperTop"
      >
        <swiper-slide
          class="slide-1"
          v-bind:style="{backgroundImage:'url('+'\'' + item.path +'\''+ ')'}"
          v-for="(item,index) in bannerArray"
          :key="index"
        > 
        </swiper-slide>
      </swiper>
      <div class="data-wrapper">
        <p class="data-title">我们的优势</p> 
        <p class="data-description">精益求精，专业靠谱的团建策划师。精心打磨，亲自体验的团建产品。年轻且专业的我们，您不考虑下么？</p>
        <p class="data-num1">{{basicInfo.tbProductNumber}}</p> 
        <p class="data-num2">{{basicInfo.tbPlayNumber}}</p> 
        <p class="data-name1">累计线上团建产品</p> 
        <p class="data-name2">累计团建玩法</p>  
        <p class="data-num3">{{basicInfo.customNumber}}</p> 
        <p class="data-num4">{{basicInfo.servicePersonNumber}}</p> 
        <p class="data-name3">累计服务企业</p> 
        <p class="data-name4">累计服务人次</p>  
        <span @click.stop="more()">更多</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { handlePicPlusPre } from "../../util/util";
export default {
  name:"adDetails",
  components: {
    
  },
  props: {},
  data() {
    return {
      id: null,
      message: {},
      bannerArray:[],
      swiperOptionTop: {
        autoplay: {
          		delay: 6000,					// 自动切换的时间间隔，单位ms
	          	disableOnInteraction: false,	// 用户操作swiper之后，是否禁止autoplay。默认为true：停止
	 	          reverseDirection: false,			// 关键代码，开启反向自动轮播
	      },
        // autoplay:5000,
        loop: true,
        slidesPerview: "auto",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        advantageSwiperLoading:false
      },      
      advantageSwiperLoading:false
    };
  },
  watch: {},
  computed: {
   getScrolltop() {
      let _this = this;
      window.addEventListener("scroll", () => {
        _this.top =
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          window.pageYOffset;
      });
      return _this.top > 300;
    },
    basicInfo() {
      return this.$store.state.webInfo;
    },
    // 获取站点城市id
    getLocationSiteCityId() {
      return this.$store.state.locationSiteCity?this.$store.state.locationSiteCity:5;
    },  
  },
  methods: {
    handlePicPlusPre,
    more(){
      console.log("更多")
      this.$router.push({
        path: "/aboutUs",
      });
    },
     // 获取广告
    getBanner() {
      const params = {
        positionId: 7,
        cityId:this.$store.state.locationSiteCity?this.$store.state.locationSiteCity:5
      };
      axios
        .get(`/api/adm/list`, {
          params,
        })
        .then((res) => {
          // console.log(res)
          if (res.data && res.data.code == 200) {
            this.bannerArray = res.data.adList;

            this.bannerArray.forEach((banner) => {
              banner.path = this.handlePicPlusPre(banner.path);
            });
            // console.log("getAdPosition-middle")
            // console.log(this.bannerArray);
          }
          // console.log("getAdPosition-end")
        });
    },
  },
  created() {

  },
  mounted() {
    this.getBanner();
  }
};
</script>
<style scoped>
.our-advantages .gallery-top {
  height: 100% !important;
  width: 100%;
}
.our-advantages .gallery-top .slide-1{
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;

  position: relative;
}
.our-advantages .gallery-top .slide-1  a {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.our-advantages .swiper-wrapper {
  position: relative;
  height: 640px;
  background: #000;
}
.our-advantages .swiper-wrapper >>> .swiper-pagination-bullet {
  background: #e4e4e4 !important;
}
.our-advantages .swiper-wrapper >>> .swiper-pagination-bullet-active {
  background: #000000 !important;
}
.our-advantages .swiper-pagination >>> span {
  width: 12px !important;
  height: 12px !important;
}
.our-advantages .data-wrapper{
    background: rgba(0,0,0,.5);
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    position: absolute;
    right: 0;
    height: 640px;
    z-index: 1000;
    width: 60%;
    /* pointer-events: none; */
}
.our-advantages .data-wrapper .data-title{
    font-size: 38px;
    color: #fff;
    position: absolute;
    left: 75px;
    top: 75px;
    font-weight: 700;
}
.our-advantages .data-wrapper .data-description{
    font-size: 18px;
    color: #fff;
    position: absolute;
    left: 75px;
    top: 152px;
    width: 500px;
}
.our-advantages .data-wrapper .data-num1{
    font-size: 38px;
    color: #fff;
    position: absolute;
    left: 75px;
    top: 227px;
    font-weight: 700;
    font-family: Bebas;
}
.our-advantages .data-wrapper .data-name1{
    font-size: 18px;
    color: #fff;
    position: absolute;
    left: 75px;
    top: 293px;
}
.our-advantages .data-wrapper .data-num2{
    font-size: 38px;
    color: #fff;
    position: absolute;
    left: 310px;
    top: 227px;
    font-weight: 700;
    font-family: Bebas;
}
.our-advantages .data-wrapper .data-name2{
    font-size: 18px;
    color: #fff;
    position: absolute;
    left: 310px;
    top: 293px;
}
.our-advantages .data-wrapper .data-num3{
    font-size: 38px;
    color: #fff;
    position: absolute;
    left: 75px;
    top: 358px;
    font-weight: 700;
    font-family: Bebas;
}
.our-advantages .data-wrapper .data-name3{
font-size: 18px;
    color: #fff;
    position: absolute;
    left: 75px;
    top: 430px;
}
.our-advantages .data-wrapper .data-num4{
    font-size: 38px;
    color: #fff;
    position: absolute;
    left: 310px;
    top: 358px;
    font-weight: 700;
    font-family: Bebas;
}
.our-advantages .data-wrapper .data-name4{
    font-size: 18px;
    color: #fff;
    position: absolute;
    left: 310px;
    top: 430px;
}
.our-advantages .data-wrapper span{
    font-size: 16px;
    color: #359FF8;
    position: absolute;
    left: 646px;
    top: 98px;
    z-index: 100;
    cursor:pointer;
}
.data-wrapper span:hover{
    cursor:pointer;
}
p{
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/home/ourAdvantages.vue